export default "__VITE_ASSET__660cb195__"